import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header/Header';
import BlogCTA from '../components/BlogCTA/BlogCTA';
import './AllPosts.css';

const allPosts = [
  { id: 1, title: "5 Signs Your Home Needs Electrical Rewiring", date: "April 15, 2026", author: "Musa Electrical Team", image: "/images/blog/blog-1.jpg", excerpt: "Is your home showing signs of electrical problems? Here are 5 warning signs that indicate you might need professional rewiring services soon.", category: "Electrical Tips" },
  { id: 2, title: "Benefits of Installing Solar Panels in Kenya", date: "April 10, 2026", author: "Musa Electrical Team", image: "/images/blog/blog-2.jpg", excerpt: "Discover how solar energy can save you money and provide reliable power in Kenya's sunny climate.", category: "Solar Energy" },
  { id: 3, title: "Choosing the Right CCTV System", date: "April 5, 2026", author: "Musa Electrical Team", image: "/images/blog/blog-3.jpg", excerpt: "A comprehensive guide to selecting the best security camera system for your home or business.", category: "Security" },
  { id: 4, title: "Electrical Safety Tips Every Homeowner Should Know", date: "March 28, 2026", author: "Musa Electrical Team", image: "/images/blog/blog-4.jpg", excerpt: "Essential electrical safety practices to protect your family and property from hazards.", category: "Safety" },
  { id: 5, title: "The Future of Smart Home Technology", date: "March 20, 2026", author: "Musa Electrical Team", image: "/images/blog/blog-5.jpg", excerpt: "Explore how smart home technology is transforming living spaces across Kenya.", category: "Technology" },
  { id: 6, title: "Cost Guide: Electrical Installation in New Buildings", date: "March 15, 2026", author: "Musa Electrical Team", image: "/images/blog/blog-6.jpg", excerpt: "Understanding the costs involved in electrical installation for new construction projects.", category: "Guides" },
  { id: 7, title: "Why You Need Professional Network Installation", date: "March 10, 2026", author: "Musa Electrical Team", image: "/images/blog/blog-5.jpg", excerpt: "Learn why professional network setup is crucial for your business connectivity.", category: "Networking" },
  { id: 8, title: "Maintenance Tips for Your Solar System", date: "March 5, 2026", author: "Musa Electrical Team", image: "/images/blog/blog-2.jpg", excerpt: "Keep your solar panels running efficiently with these essential maintenance tips.", category: "Solar Energy" }
];

const categories = ['All', 'Electrical Tips', 'Solar Energy', 'Security', 'Safety', 'Technology', 'Guides', 'Networking'];

const AllPosts = () => {
  const [activeCategory, setActiveCategory] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');

  const filteredPosts = allPosts.filter(post => {
    const matchesCategory = activeCategory === 'All' || post.category === activeCategory;
    const matchesSearch = post.title.toLowerCase().includes(searchTerm.toLowerCase()) || post.excerpt.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  return (
    <div className="page-wrapper">
      <div className="hero-wrapper">
        <Header />
        <div className="page-hero">
          <div className="page-hero-overlay"></div>
          <div className="page-hero-content">
            <h1>All Posts</h1>
            <p>Browse our complete collection of articles and guides</p>
            <div className="breadcrumb">
              <a href="/">Home</a><span className="sep">/</span>
              <a href="/blog">Blog</a><span className="sep">/</span>
              <span className="active">All Posts</span>
            </div>
          </div>
        </div>
      </div>

      <div className="allposts-container">
        <div className="search-box">
          <input type="text" placeholder="Search articles..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className="search-input" />
          <span className="search-icon">🔍</span>
        </div>

        <div className="scrollable-tabs-wrapper">
          <div className="scrollable-tabs">
            <div className="tabs-list">
              {categories.map((cat) => (
                <button key={cat} className={`tab-trigger ${activeCategory === cat ? 'active' : ''}`} onClick={() => setActiveCategory(cat)}>{cat}</button>
              ))}
            </div>
          </div>
          <div className="scroll-bar">
            <div className="scroll-bar-thumb" style={{ width: `${(1 / categories.length) * 100}%` }} />
          </div>
        </div>

        <p className="results-count">{filteredPosts.length} article{filteredPosts.length !== 1 ? 's' : ''} found</p>

        <div className="allposts-list">
          {filteredPosts.map((post) => (
            <article className="post-row slide-up" key={post.id}>
              <div className="post-row-image">
                <img src={process.env.PUBLIC_URL + post.image} alt={post.title} />
              </div>
              <div className="post-row-content">
                <div className="post-row-meta">
                  <span className="post-row-category">{post.category}</span>
                  <span className="post-row-date">{post.date}</span>
                  <span className="post-row-author">By {post.author}</span>
                </div>
                <h2>{post.title}</h2>
                <p>{post.excerpt}</p>
                <div className="post-row-footer">
                  <Link to={`/blog/${post.id}`} className="read-btn">Read Article →</Link>
                  <a href="tel:0796049254" className="enquire-btn">📞 Enquire</a>
                </div>
              </div>
            </article>
          ))}
        </div>

        {filteredPosts.length === 0 && (
          <div className="no-results"><h3>No articles found</h3><p>Try adjusting your search or filter criteria</p></div>
        )}
      </div>

      {/* CTA + Subscribe */}
      <BlogCTA />
    </div>
  );
};

export default AllPosts;
